"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionName = exports.ExtensionId = void 0;
var ExtensionId;
(function (ExtensionId) {
    ExtensionId[ExtensionId["mval"] = 0] = "mval";
    ExtensionId[ExtensionId["cnt"] = 1] = "cnt";
    ExtensionId[ExtensionId["peritext"] = 2] = "peritext";
    ExtensionId[ExtensionId["quill"] = 3] = "quill";
    ExtensionId[ExtensionId["prosemirror"] = 4] = "prosemirror";
})(ExtensionId || (exports.ExtensionId = ExtensionId = {}));
var ExtensionName;
(function (ExtensionName) {
    ExtensionName[ExtensionName["mval"] = 0] = "mval";
    ExtensionName[ExtensionName["cnt"] = 1] = "cnt";
    ExtensionName[ExtensionName["peritext"] = 2] = "peritext";
    ExtensionName[ExtensionName["quill"] = 3] = "quill";
    ExtensionName[ExtensionName["prosemirror"] = 4] = "prosemirror";
})(ExtensionName || (exports.ExtensionName = ExtensionName = {}));
